module.exports = __webpack_public_path__ + "media/images/projects-9f94a3307ad74c6be913eb2ea06594d5.svg";